import { render, staticRenderFns } from "./LivePlatformOption.vue?vue&type=template&id=ab76d628"
import script from "./LivePlatformOption.vue?vue&type=script&lang=js"
export * from "./LivePlatformOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports